<header class="header">
  <div class="header-left">
    <img
      src="assets\logos\rocketclose-clearsign-logo.svg"
      alt="{{ 'header.LOGOALTTEXT' | translate }}"
      class="logo"
    />
  </div>

  <div class="header-right">
    <!-- Tablet & Desktop Items -->
    <div class="tablet-desktop-items">
      <app-language-selector></app-language-selector>
      <div>
        <button
          novaButton
          appTrackedButton
          [trackId]="'header:call-support'"
          variant="tertiary"
          [attr.aria-label]="'header.CALL_SUPPORT_TITLE' | translate"
          [title]="'header.CALL_SUPPORT_TITLE' | translate"
          (click)="callSupport()"
        >
          {{ phoneNumber }}
          <nova-icon class="nova-button__icon-right" name="phone_in_talk" />
        </button>
      </div>
    </div>

    <!-- User Menu Trigger -->
    <button
      novaButton
      appTrackedButton
      [trackId]="'header:user-menu'"
      [trackType]="'expand'"
      variant="tertiary"
      [matMenuTriggerFor]="userMenu.userMenu()"
      aria-haspopup="true"
      [aria-label]="participantName()"
      [title]="'header.USER_MENU_TITLE' | translate"
    >
      <nova-icon name="account_circle" class="mobile-tablet-icon"></nova-icon>
      <span class="desktop-text">{{ participantName() }}</span>
      <div class="participant-avatar">
        {{ participantInitial }}
      </div>
    </button>

    <app-user-menu
      #userMenu
      [participantName]="participantName()"
      [showExitSigning]="screenSize.isDesktop() === false && !isExitSigningHeader()"
      [showPhoneOption]="screenSize.isTabletOrDesktop() === false"
      [showLanguageOption]="screenSize.isTabletOrDesktop() === false"
      [showParticipantName]="screenSize.isDesktop() === false"
      [phoneNumber]="phoneNumber"
      (exitSigningClicked)="exitSigning()"
    ></app-user-menu>

    <!-- Desktop Only Items -->
    <div class="desktop-only">
       @if (!isExitSigningHeader()) {
          <button
            novaButton
            appTrackedButton
            [trackId]="'header:exit-signing'"
            [trackType]="'sign_out'"
            variant="secondary"
            [attr.aria-label]="'header.EXIT_SIGNING' | translate"
            [title]="'header.EXIT_SIGNING' | translate"
            (click)="exitSigning()"
          >
            {{ "header.EXIT_SIGNING" | translate }}
          </button>
      }
    </div>
  </div>
</header>

<app-exit-signing-modal #exitModal></app-exit-signing-modal>
